import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
// mui components
import { Button, Tooltip, Typography } from '@mui/material';
// custom hooks
import { useTooltipStyles } from '../../hooks/use-tooltip-styles';
// api
// styles
import { IPost } from '_interfaces/post.interface';
import { useGetProfilesQuery } from 'redux-store/api/profiles';
import { postItemStyles as styles } from '../../styles/styles';

interface IProps {
  post: IPost;
}

const LikesCount: FC<IProps> = ({ post }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: profiles } = useGetProfilesQuery(undefined);

  const classes = useTooltipStyles();

  if (!post.likes?.length) {
    return (
      <Button size="small" sx={styles.postInfoBtn}>
        <Typography sx={styles.withoutUnderline}>{`${0} like`}</Typography>
      </Button>
    );
  }

  const onButtonClick = () => {
    searchParams.set('likesPostId', post.id);
    setSearchParams(searchParams);
  };

  const tooltipTitle = (
    <>
      {post.likes?.slice(0, 4)?.map((item) => {
        const user = profiles?.items.find((u) => u.id?.toString() === item.toString());
        if (!user) return null;
        return (
          <Typography sx={styles.likeInfo} key={item}>
            {`${user?.firstName} ${user?.lastName}`}
          </Typography>
        );
      })}
      <Typography sx={styles.likeInfo}>
        {post.likes?.length > 4 && `and ${post.likes?.length - 4} more`}
      </Typography>
    </>
  );

  return (
    <Tooltip
      classes={classes}
      placement={'bottom-start'}
      title={tooltipTitle}
    >
      <Button size="small" sx={styles.postInfoBtn} onClick={onButtonClick}>
        <Typography sx={styles.hoverUnderline}>
          {post.likes?.length === 1 ? `${1} like ` : `${post.likes?.length} likes`}
        </Typography>
      </Button>
    </Tooltip>
  );
};

export default LikesCount;
